// Fuentes de datos para el gráfico de Distribución de Mejoras

export const improvementSources = [
  {
    name: 'Estudio de Productividad Empresarial 2023',
    organization: 'Instituto de Investigación Empresarial',
    year: '2023',
    description:
      'Análisis detallado sobre cómo las mejoras tecnológicas impactan la productividad operativa en empresas de diversos tamaños.',
    url: 'https://www.mckinsey.com/capabilities/operations/our-insights/operations-practice/improving-productivity-in-manufacturing-and-service-operations',
  },
  {
    name: 'Reporte de Optimización de Costos',
    organization: 'Consultora Global de Negocios',
    year: '2023',
    description:
      'Investigación sobre estrategias de reducción de costos operativos mediante implementación tecnológica y optimización de procesos.',
    url: 'https://www2.deloitte.com/global/en/pages/operations/articles/cost-reduction-strategies.html',
  },
  {
    name: 'Índice de Satisfacción del Cliente',
    organization: 'Asociación de Experiencia del Cliente',
    year: '2023',
    description:
      'Estudio que mide el impacto de las mejoras tecnológicas en la satisfacción y retención de clientes en diferentes industrias.',
    url: 'https://www.hubspot.com/customer-satisfaction',
  },
  {
    name: 'Tendencias de Innovación Empresarial',
    organization: 'Centro de Innovación Tecnológica',
    year: '2023',
    description:
      'Análisis de cómo la innovación tecnológica genera nuevas oportunidades de negocio y ventajas competitivas sostenibles.',
    url: 'https://www.mckinsey.com/capabilities/strategy-and-corporate-finance/our-insights/innovation-in-a-crisis-why-it-is-more-critical-than-ever',
  },
  {
    name: 'Estudio de Cumplimiento Normativo',
    organization: 'Instituto de Regulación y Seguridad Digital',
    year: '2023',
    description:
      'Investigación sobre el impacto de las mejoras en sistemas de seguridad y cumplimiento normativo en la reducción de riesgos empresariales.',
    url: 'https://www2.deloitte.com/global/en/pages/risk/articles/compliance-modernization.html',
  },
];

// Mapeo de métricas a sus fuentes correspondientes
export const metricToSourceMap: Record<string, string[]> = {
  Productividad: ['Estudio de Productividad Empresarial 2023'],
  'Reducción Costos': ['Reporte de Optimización de Costos'],
  'Satisfacción Cliente': ['Índice de Satisfacción del Cliente'],
  Innovación: ['Tendencias de Innovación Empresarial'],
  Cumplimiento: ['Estudio de Cumplimiento Normativo'],
};
